import { defineStore } from "pinia";
import type { User } from "types/shim";

export const useUserStore = defineStore("user", () => {
  const user = ref<User>({} as User);
  const isLoggedIn = computed(() => !!user.value.user_id);
  function setUser(data: User = {} as User) {
    user.value = data;
  }

  return { user, setUser, isLoggedIn };
});
